import React from 'react';
import ListChoiceEditor from './ListChoiceEditor';
import { standardColor } from 'js/utils/color';
import ValueChoice from './Choices/ValueChoice';

export function MultiSelectChoiceEditor({
  onAddChoice,
  onChoiceUpdate,
  ...props
}) {
  const handleAddChoice = (choiceLength) => {
    const nextNumber = choiceLength + 1;
    const text = `Choice ${nextNumber}`;
    const newChoice = {
      value: text,
      text,
    };
    onAddChoice(newChoice);
  };

  const handleUpdateChoice = (...args) => {
    console.log({ args });
    onChoiceUpdate(...args);
  };

  return (
    <ListChoiceEditor
      color={standardColor}
      {...props}
      choiceTag={ValueChoice}
      onAddChoice={handleAddChoice}
      onChoiceUpdate={handleUpdateChoice}
    />
  );
}

export default MultiSelectChoiceEditor;
